import { useContext } from "react";
import TaxNumbers from "./Contact/TaxNumbers";
import BankAccount from "./Contact/BankAccount";
import LetterHead from "./Contact/LetterHead";
import ContactMailPhone from "./Contact/ContactMailPhone";
import ProfileWeb from "./Contact/ProfileWeb";
import { WindowContext } from "../Service/Context/WindowContext";
import { ResourceContext } from "../Service/Context/ResourceContext";
import { LoadingAnimation } from "../Service/ResourceAdapter";
import AdditionalInfo from "./Contact/AdditionalInfo";

const FooterContact = ({ documentType, contract, language, documentLayoutPlacement }) => {
  const { documentLayout, profile, loading } = useContext(ResourceContext);
  const { windowWidth } = useContext(WindowContext);

  if (loading) {
    return <LoadingAnimation />;
  }

  const placement = documentLayoutPlacement ?? documentLayout.infoBoxPlacement;
  const footerStyles = contract ? contract.contractFooter : placement;

  if (!footerStyles || footerStyles === "NONE" || footerStyles === "RIGHT") {
    return null;
  }

  let styles = {
    blockStyle: {
      display: "flex",
      justifyContent: "space-evenly",
      textAlign: "justify",
      fontSize: 12,
      flexDirection: windowWidth > 550 ? "row" : "column",
      marginTop: 30,
    },
    centerStyle: {
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      alignItems: "center",
    },
  };

  const blocks = footerStyles === "BLOCKS" || placement === "JUSTIFIED";
  const additionalInfos = profile.additionalInfo01 || profile.additionalInfo02 || profile.additionalInfo03;
  const showFinancialInfo = documentType !== "QUESTIONNAIRE";

  return (
    <div style={blocks ? styles.blockStyle : styles.centerStyle}>
      <div style={{ paddingLeft: 10 }}>
        <LetterHead inline={!blocks} />
        {additionalInfos && <ContactMailPhone inline={!blocks} language={language}/>}
      </div>
      {!additionalInfos && <div style={{paddingLeft: 10}}>
        <ContactMailPhone inline={!blocks} language={language}/>
        <ProfileWeb inline={!blocks} language={language}/>
      </div>}
      {additionalInfos && <div style={{paddingLeft: 10}}>
        <AdditionalInfo inline={!blocks}/>
      </div>}
      {showFinancialInfo && (
        <>
          <div style={{ paddingLeft: 10 }}>
            <TaxNumbers inline={!blocks} language={language} />
          </div>
          <div style={{ paddingLeft: 10 }}>
            <BankAccount inline={!blocks} documentType={documentType} />
          </div>
        </>
      )}
    </div>
  );
};

export default FooterContact;
